import React from "react";
import Select from "react-select";

const TimePickerComponent = ({ label, time, handleTimeSelectChange, type, orientation }) => {
  const hourOptions = Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    label: (i + 1).toString(),
  }));

  const minuteOptions = [
    { value: "00", label: "00" },
    { value: "30", label: "30" },
  ];

  const ampmOptions = [
    { value: "AM", label: "AM" },
    { value: "PM", label: "PM" },
  ];

  return (
    <>
      <div className="">
        <label htmlFor="time">{label}</label>
        <div className="time-picker-container">
          <Select
            isSearchable={false}
            menuPlacement={orientation || "auto"} // Automatically chooses the direction
            menuPosition="fixed" // Ensures consistent positioning
            classNamePrefix="time-select"
            className="time-picker-select"
            options={hourOptions}
            // menuPortalTarget={document.body}
            // styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            value={{ label: time.hours.toString(), value: time.hours }}
            onChange={(selected) =>
              handleTimeSelectChange("hours", selected.value, type)
            }
          />
          <Select
            menuPlacement={orientation || "auto" } // Automatically chooses the direction
            menuPosition="fixed"
            isSearchable={false}
            className="time-picker-select"
            classNamePrefix="time-select"
            options={minuteOptions}
            // menuPortalTarget={document.body}
            // styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            value={{
              label: time.minutes === "00" ? "00" : "30",
              value: time.minutes,
            }}
            onChange={(selected) =>
              handleTimeSelectChange("minutes", selected.value, type)
            }
          />
          <Select
            menuPlacement={orientation || "auto" } // Automatically chooses the direction
            menuPosition="fixed"
            isSearchable={false}
            className="time-picker-select"
            options={ampmOptions}
            // menuPortalTarget={document.body}
            // styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            classNamePrefix="time-select"
            value={{ label: time.ampm, value: time.ampm }}
            onChange={(selected) =>
              handleTimeSelectChange("ampm", selected.value, type)
            }
          />
        </div>
      </div>
    </>
  );
};

export default TimePickerComponent;
